/**
 * @namespace
 */

let account = {};

/**
 *登陆
 *
 * @param email
 * @param password
 * @returns {Object}
 */

account.login = async function(email,password){
    let url = '/account/login',
        data = {
            email,
            password
        };

    try{
        let res = await axios.post(url,data);
        return res;
    }catch(err){
        console.log('gggg',err);
    }

    return null;

}


/**
 *退出登录
 *
 * @returns {Object}
 */

account.logout = async function(){

    let url = '/account/login';

    try{
        let res = await axios.put(url);
        return res;
    }catch(err){
        console.log(err);
    }

    return null;
}


/**
 *检测邮箱
 *
 * @param  email
 * @returns {Object}
 */

account.checkEmail = async function(email,tips="请检查服务器地址是否正确"){

    let url = '/account/check_email3',
        data = {
            email:email.trim()
        }

    try{
        let res = await axios.put(url,data);
        return res;
    }catch(err){

        vm.eventBus.$emit('resetSetting');
        // vm.eventBus.$emit('showTip','请检查服务器地址是否正确','failed');
        vm.eventBus.$emit('showTip',tips,'failed');

        console.log(err);
    }

    return null;
}


/**
 *获取用户信息
 *
 * @returns {Object}
 */

account.getUserInfo = async function(){

    let url = '/account/userinfo';

    try{
        let res = await axios.get(url);
        return res;
    }catch(err){
        console.log(err);
    }

    return null;
}


/**
 *找回密码
 *
 * @param email
 * @returns {Object}
 */

account.retrievePassword = async function(email){

    let url = '/account/reset_password',
        data = {
            email
        };

    try{
        let res = await axios.post(url,data);
        return res;
    }catch(err){
        console.log(err);
    }

    return null;
}

export default account;

